import { useEffect } from "react";
import { initAppInsights } from "../services/appInsightsService";
import { useAuth } from '../context/AuthContext';

/**
 * Hook that initialises Application Insights with the authenticated user.
 *
 * Usage – add to App.js (or any top-level component rendered after login):
 *
 *   import useAppInsights from "./hooks/useAppInsights";
 *
 *   function App() {
 *     useAppInsights();          // ← add this line
 *     // ... rest of App
 *   }
 */
export default function useAppInsights() {
  const { user } = useAuth();

  useEffect(() => {
    if (user) initAppInsights(user.id, user.nombre || user.email);
  }, [user]);
}
